import React from "react";
import { Table } from "react-bootstrap";

export default function ProcessHistory({ rows = [] }) {
  return (
    <div className="table-responsive">
      <Table size="sm" hover className="align-middle">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Canal</th>
            <th>Resultado</th>
            <th>Número</th>
            <th>Duración</th>
            <th>Observación</th>
            <th>Evidencia</th>
            <th>Estado nuevo</th>
          </tr>
        </thead>
        <tbody>
          {!rows.length ? (
            <tr>
              <td colSpan={8} className="text-center text-muted py-3">
                Sin historial todavía.
              </td>
            </tr>
          ) : (
            rows.map((item) => (
              <tr key={item.id}>
                <td>{item.fecha || "-"}</td>
                <td>{item.canal || "-"}</td>
                <td>{item.resultado || "-"}</td>
                <td>{item.numeroContactado || "-"}</td>
                <td>{item.duracionSegundos ? `${item.duracionSegundos}s` : "-"}</td>
                <td>{item.observacion || "-"}</td>
                <td>{item.evidenciaReferencia || "-"}</td>
                <td>{item.estadoNuevo || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}
